import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchVehicleWiseCollection({
  cityFilter = [],
  operatorFilter = [],
  operationType = "",
  pageNo,
  pageSize = 10,
  searchString,
  sortBy,
  dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/vehicleWiseCollectionData`;
  return newReconServiceAPI(url, {
    search: searchString,
    sort: sortBy || { busNumber: 1 },
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      date: dateFilter,
      operationType,
    },
    pageNo,
    pageSize,
  });
}

export function fetchDayWiseCollection({
  cityFilter = [],
  operatorFilter = [],
  operationType = "",
  pageNo,
  pageSize = 10,
  sortBy,
  dateFilter = {},
}) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/dayWiseCollectionData`;
  return newReconServiceAPI(url, {
    sort: sortBy || { busNumber: 1 },
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      date: dateFilter,
      operationType,
    },
    pageNo,
    pageSize,
  });
}

export function fetchCollectionSummary({
  cityFilter = [], operationType = "", operatorFilter = [], dateFilter = {}, busNumber = "",
}) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/collectionSummary`;
  return newReconServiceAPI(url, {
    limit: 20,
    addOnFilter: {
      cityIdArr: cityFilter,
      operatorIdArr: operatorFilter,
      date: dateFilter,
      operationType,
      busNumber,
    },
  });
}

export function markCollection({ markOption, selectedData }) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/markLiveAndNoLive`;
  return newReconServiceAPI(url, {
    selectedData,
    updates: {
      status: markOption,
    },
  });
}

export function markEditCollection({ updates, selectedData }) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/updateContractForDay`;
  return newReconServiceAPI(url, {
    selectedData,
    updates,
  });
}

export function uploadBulkEditGCSheets(data) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/uploadBulkEditGCSheet`;
  // URL needs confirmation
  return newReconServiceAPI(url, {
    ...data,
  });
}
